import { useEffect, useState } from 'react';
import { Container, Image, ImageExpanded, Background } from './ImageViewer.styled';
import { ImageViewerType } from '../../types/ImageViewerType';
import { Tooltip } from '@mui/material';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { BASE_URL } from '../../services/api';

export function ImageViewer({ imageAnswerValues, projectId = '' }: ImageViewerType) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [expanded, setExpanded] = useState<boolean>(false);
  const [s3BucketUrl, setS3BucketUrl] = useState<string>('');

  const checkEnvironment = () => {
    const url = BASE_URL.split('/');

    if(url.includes('development')) {
      setS3BucketUrl('https://project-handler.s3.sa-east-1.amazonaws.com/answer-field-values/');
      return;
    }
    setS3BucketUrl(`https://project-handler-data-prod.s3.sa-east-1.amazonaws.com/answer-field-values/${projectId}/`);
  };

  const handlePrevClick = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : imageAnswerValues.length - 1));
  };

  const handleNextClick = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageAnswerValues.length - 1 ? prevIndex + 1 : 0));
  };

  const handleImageClick = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    document.body.style.overflow = expanded == true ? 'hidden' : '';
    checkEnvironment();
  }, [expanded]);

  return (
    <>
      {imageAnswerValues?.length > 0 && (
        <>
          <Container>
            <Image
              key={imageAnswerValues[currentImageIndex].answer_field_value.id}
              src={`${s3BucketUrl}${imageAnswerValues[currentImageIndex].answer_field_value?.value}`}
              alt={imageAnswerValues[currentImageIndex].title}
              onClick={() => handleImageClick()}
            />
            {imageAnswerValues?.length > 1 && (
              <div style={{ position: 'absolute', width: '100%', display: 'flex', justifyContent: 'space-between', paddingLeft: 5, paddingRight: 5 }}>
                <Tooltip title='Anterior'>
                  <KeyboardArrowLeftRoundedIcon onClick={handlePrevClick} sx={{ cursor: 'pointer', color: '#fff', fontSize: '60px', zIndex: 9999 }} />
                </Tooltip>
                <Tooltip title='Próxima'>
                  <KeyboardArrowRightRoundedIcon onClick={handleNextClick} sx={{ cursor: 'pointer', color: '#fff', fontSize: '60px', zIndex: 9999 }} />
                </Tooltip>
              </div>
            )}
          </Container>

          {expanded && (
            <Background>
              <ImageExpanded
                src={`${s3BucketUrl}${imageAnswerValues[currentImageIndex].answer_field_value.value}`}
                alt={`Image ${currentImageIndex + 1}`}
                onClick={handleImageClick}
              />
              <div style={{ position: 'absolute', width: '100%', display: 'flex', justifyContent: 'space-between', paddingLeft: 5, paddingRight: 5 }}>
                <Tooltip title='Anterior'>
                  <KeyboardArrowLeftRoundedIcon onClick={handlePrevClick} sx={{ cursor: 'pointer', color: '#fff', fontSize: '60px', zIndex: 9999 }} />
                </Tooltip>
                <Tooltip title='Próxima'>
                  <KeyboardArrowRightRoundedIcon onClick={handleNextClick} sx={{ cursor: 'pointer', color: '#fff', fontSize: '60px', zIndex: 9999 }} />
                </Tooltip>
              </div>
            </Background>
          )}
        </>
      )}
    </>
  );
}
